export const SET_NEW_GROUP_LIST = 'SET_NEW_GROUP_LIST';